// Copyright 2020 Prescryptive Health, Inc.

import { IBusyAction } from './busy.action';

export type IBusyPopAction = IBusyAction<'BUSY_POP'>;

export const busyPopAction = (): IBusyPopAction => ({
  type: 'BUSY_POP',
});
